module.exports = __webpack_public_path__ + "img/04.39e3ce0c.jpg";